import(/* webpackMode: "eager", webpackExports: ["VaultClient"] */ "/codebuild/output/src2094359739/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/vaults/[id]/VaultClient.tsx");
